import * as yup from 'yup'
import { mediaSchema, validateMedia } from '@/components/inputs'
import { OTHER_GEDRAG_OPTION_VALUE } from '@/components/forms/ObservationLogFormContainer/fieldsOptions'

export const schema = yup.object({
  specie: yup.string().required(),
  amount: yup.string().required(),
  counting_method: yup.string().required(),
  behaviour: yup.string().required(),
  other_behaviour: yup.string().when('behaviour', {
    is: OTHER_GEDRAG_OPTION_VALUE,
    then: (schema) => schema.required(),
  }),
  behaviour_notes: yup.string().max(256),
  recording_number: yup
    .string()
    .transform((value) => (value === '' || value === null ? undefined : value)),
  observed_at: yup.date().required(),
  photos: mediaSchema,
  sound_recordings: mediaSchema.test((value, context) =>
    validateMedia({
      value,
      minItems: 0,
      maxItems: 1,
      accept: 'audio/wav,audio/x-wav',
      context,
      description: true,
    })
  ),
})
